

// models/Usage.js - Dedicated usage model
export class Usage {
  constructor(data = {}) {
    this.daily = {
      reports: data.daily?.reports || 0,
      liveReports: data.daily?.liveReports || 0,
      voiceUploads: data.daily?.voiceUploads || 0,
      transcriptions: data.daily?.transcriptions || 0
    };
    
    this.limits = {
      maxDailyReports: data.limits?.maxDailyReports || 0,
      maxDailyLiveReports: data.limits?.maxDailyLiveReports || 0,
      maxDailyTranscriptions: data.limits?.maxDailyTranscriptions || 0,
      liveReportsEnabled: data.limits?.liveReportsEnabled || false,
      macrosEnabled: data.limits?.macrosEnabled || false,
      customInstructionsEnabled: data.limits?.customInstructionsEnabled || false,
      customReportTypesEnabled: data.limits?.customReportTypesEnabled || false,
      languageSelectionEnabled: data.limits?.languageSelectionEnabled || false,
      maxHistoryDays: data.limits?.maxHistoryDays || -1,
      translatorEnabled: data.limits?.translatorEnabled || false
    };
    
    this.planType = data.planType || null;
    this.resetAt = data.resetAt ? new Date(data.resetAt) : null;
  }
}